import { render } from "./TodayLecture.vue?vue&type=template&id=781eb980&scoped=true"
import script from "./TodayLecture.vue?vue&type=script&lang=js"
export * from "./TodayLecture.vue?vue&type=script&lang=js"

import "./TodayLecture.vue?vue&type=style&index=0&id=781eb980&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\Edu Katta\\Edukataa APP-Admin\\Edukatta_UI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-781eb980"]])

export default __exports__